import React from 'react'
import classes from '../Content.module.scss'

const ContentButton = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(({
  className,
  onClick,

  children,

  ...restProps
}, ref) => {
  let compClassName = classes.button
  if (className) compClassName += ' ' + className
  if (onClick) compClassName += ' ' + classes.hoverable

  return (
    <div
      {...restProps}
      ref={ref}
      className={compClassName}
      onClick={onClick}
    >
      {children}
    </div>
  )
})

export default ContentButton
